import axios from "axios";


export async function getPublicKey() {
  const result = await( axios.get(`/assets/keys/customer-sdk-public.pem`))

  return result.data
}